/**
 * src/utils/api.js
 * HTTP Request wrapper
 * Wraps around the AXIOS library
 */
import axios from "axios";

class ApisClient {
  constructor(chatConfig) {
    this.chatConfig = chatConfig;
  }

  _getUri(endpoint, query) {
    let uri = this.chatConfig.chatbot.host + endpoint;
    const keys = Object.keys(query);
    const values = Object.values(query);

    for (let i = 0; i < keys.length; i++) {
      uri = uri.replace("[" + keys[i] + "]", values[i]);
    }

    return uri;
  }

  get(endpoint, query, params, headers = {}) {
    query = query || {};
    params = params || {};

    const uri = this._getUri(endpoint, query);

    return new Promise((resolve, reject) => {
      axios.get(uri, {
        withCredentials: true,
        params,
        headers
      }).then(response => {
        if (response.data.error) {
          return reject(response.data.error);
        }

        return resolve(response.data.data);
      }).catch(error => {
        return reject(error);
      });
    });
  }

  post(endpoint, query, params, data, headers = {}) {
    query = query || {};
    params = params || {};

    const uri = this._getUri(endpoint, query);

    return new Promise((resolve, reject) => {
      axios.post(uri, data, {
        withCredentials: true,
        params,
        headers
      }).then(response => {
        if (response.data.error) {
          return reject(response.data.error);
        }

        return resolve(response.data.data ? response.data.data : response.data);
      }).catch(error => {
        return reject(error);
      });
    });
  }

  put(endpoint, query, params, data, source = false) {
    query = query || {};
    params = params || {};

    const uri = this._getUri(endpoint, query, source);

    const headers = this._getHeaders(source);

    return new Promise((resolve, reject) => {
      axios.put(uri, data, {
        withCredentials: true,
        params,
        headers
      }).then(response => {
        if (response.data.error) {
          return reject(response.data.error);
        }

        return resolve(response.data.data);
      }).catch(error => {
        return reject(error);
      });
    });
  }

  delete(endpoint, query, params, data, source = false) {
    query = query || {};
    params = params || {};

    const uri = this._getUri(endpoint, query, source);

    const headers = this._getHeaders(source);

    return new Promise((resolve, reject) => {
      axios.delete(uri, {
        withCredentials: true,
        params,
        headers
      }).then(response => {
        if (response.data.error) {
          return reject(response.data.error);
        }

        return resolve(response.data.data);
      }).catch(error => {
        return reject(error);
      });
    });
  }

}

export default ApisClient;